import { AddressModel } from "./AddressModel";

class OrganizationModel {
    public Id: number;
    public Name: string;
    public Addresses: AddressModel[];
    public IsActive: boolean;

    public constructor(init?: Partial<OrganizationModel>) {
        Object.assign(this, init);
    }
}

export { OrganizationModel };
